export const tools = {

  // PROJECTS GET OBJECTS
  // =================  

  // Récupère les projets parents (array) => array
  projParents: projects => projects.filter(project => project.parent == null),
  // Récupère les projets enfants (array) => array
  projChilds: projects => projects.filter(project => project.parent != null),
  // Récupère les noms des projets (array) => array
  projNames: projects => projects.map(project => project.name),
  // Prend seulement les enfants d'un parent (object, array) => array
  // (childsProj peut être tous les projets)
  projChildsParent: (parentProj, childsProj) => (
    childsProj.filter(childProj => childProj.parent == parentProj.uuid)
  ),



  // PROJECTS MANAGE SELECT
  // =================

  // Crée un tableau de string :  PARENT1, PARENT1/enfant1, PARENT1/enfant2,PARENT2,... (array) => array
  projParentsChilds(projects) {
    let parents = this.projParents(projects);
    let allChilds = this.projChilds(projects);
    if (!parents.length || !allChilds)
      return [];
    let parentsChilds = [];
    parents.forEach((parent) => {
      let childs = this.projChildsParent(parent, allChilds);
      if (childs.length)
        childs.forEach(child => child.name = `${parent.name}/${child.name}`);
      parentsChilds.push(parent, ...childs);
    });
    parentsChilds = parentsChilds.map((proj) => proj.name);
    return parentsChilds;
  },

  // Crée un tableau d'objets Parents qui contiennent leurs enfants.
  // (projects) => [{name: "", uuid: "", childs: [{name: "", uudi: ""}, {}]}]
  projTreeParentsChilds(projects) {
    let parents = this.projParents(projects);
    let childs = this.projChilds(projects);
    parents = parents.map((parent) => {
      parent.childs = this.projChildsParent(parent, childs);
      return parent;
    });
    return parents;
  },
  // même que au dessus mais différencie bien dans l'objet de sortie => [{parent: {}, childs: [{}]}]
  projObjParentsChilds(projects) {
    let parents = this.projParents(projects);
    let childs = this.projChilds(projects);

    let parentsChilds = [];
    parents.forEach(parent => {
      let childOfParent = this.projChildsParent(parent, childs);
      childOfParent = childOfParent.sort((proj1, proj2) => {
        if (proj1.name.toLowerCase() < proj2.name.toLowerCase()) return -1;
        return 1;
      });
      childOfParent.forEach(child => child.name = '— ' + child.name);
      childOfParent.unshift(parent);
      let newElem = {
        parent: parent,
        all: childOfParent
      };
      this.$set(newElem, 'selected', parent);
      parentsChilds.push(newElem);

    });
    return parentsChilds;
  },
  // LATEST PROJECTS
  async organizeLatestProj(lastProj) {
    let allProjects = this.$store.getters["project/getProjects"];
    if (allProjects === 'null')
      allProjects = await this.$store.dispatch("project/getProjects");
    allProjects = JSON.parse(JSON.stringify(allProjects));
    let allParents = this.projParents(allProjects);
    let childs = this.projChilds(allProjects);
    let lastProjParents = lastProj.map(proj => {
      if (!proj.parent) return proj;
      return allParents.find(parent => {
        return parent.uuid === proj.parent;
      });
    })
    let parentsChilds = [];
    lastProjParents.forEach((parent, index) => {
      let childOfParent = this.projChildsParent(parent, childs);
      childOfParent = childOfParent.sort((proj1, proj2) => {
        if (proj1.name.toLowerCase() < proj2.name.toLowerCase()) return -1;
        return 1;
      });
      childOfParent.forEach(child => {
        if (child.name.slice(0, 2) !== '— ') {
          child.name = '— ' + child.name;
        }
      });
      childOfParent.unshift(parent);
      let newElem = {
        parent: parent,
        all: childOfParent
      };
      if (lastProj[index].parent) {
        var copyChild = JSON.parse(JSON.stringify(lastProj[index]));
        if (copyChild.name.slice(0, 2) !== '— ') {
          copyChild.name = '— ' + copyChild.name;
        }
        this.$set(newElem, 'selected', copyChild);
      } else
        this.$set(newElem, 'selected', lastProj[index]);
      parentsChilds.push(newElem);
    })
    return parentsChilds;
  },


  // Retrouve un project depuis son nom et son uuid-parent (array, string, string) => object // Si pas trouvé, retourne undefined
  projFind: (projects, projName, uuidProjParent = null) => projects.filter((proj) => (projName == proj.name && uuidProjParent == proj.parent))[0],

  // Crée un projet parent ou enfant si "parent" est spécifié (object) => object
  async projCreate(nameProj, tagsProj, uuidParent = null) {
    let data = {
      parent: uuidParent,
      name: nameProj,
      tags: tagsProj
    };
    let newProj = await this.$store.dispatch("project/createProject", data);
    return newProj
  },

  // Création de projet parent/enfant ou sélection du projet où aller en fonction du select du combobox Parent/Enfant puis retourne le projet réelement sélectionné pour la fonctionnalité. (string, array) => Object
  async selectOrCreateProjects(selectedProject, projects) {
    let [parentName, childName] = selectedProject.split('/');
    let projParent = this.projFind(projects, parentName);
    let uuidProjParent = projParent !== undefined ? projParent.uuid : false;
    let projChild = this.projFind(projects, childName, uuidProjParent);
    let childSet = childName !== undefined;
    let parentExist = projParent !== undefined;
    let childExist = projChild !== undefined;
    // let uploadedImages = this.$store.getters["image/getPreviews"];
    let projectToGo;
    if (parentExist) {
      if (childSet) {
        if (childExist) {
          // add photos to existing child
          projectToGo = projChild;
        } else
          // create new Child
          // add photos to new Child
          projectToGo = await this.projCreate(childName, this.tags, projParent.uuid);
      } else
        // add photos to existing Parent
        projectToGo = projParent;
    } else {
      let newProjParent = await this.projCreate(parentName, this.tags, null);
      // create Parent
      if (childSet) {
        // Create Child
        // Add Photos to new Child
        projectToGo = await this.projCreate(childName, this.tags, newProjParent.uuid);
      } else {
        // Add photos to new Parent
        projectToGo = newProjParent;
      }
    }
    return projectToGo;
  },


  // // PROJECTS LATEST
  // // =================
  // setLatest

  // ANALYZES
  // =================

  // upload toutes les images pour l'analyze (array, object) => undefined
  async analyzeUpload(images, project, kindOfProject) {
    let keyEnvKindProj = 'VUE_APP_KIND_PROJECT_' + kindOfProject.toUpperCase();
    let valEnvKindProj = process.env[keyEnvKindProj];
    let promises = images.map(img => {
      let formData = new FormData();
      formData.append("file_url", img);
      formData.append("name", img.name);
      formData.append("media_type", "IMG");
      formData.append("content_type", valEnvKindProj);
      formData.append("project", project.uuid);
      formData.append("width", img.width);
      formData.append("height", img.height);
      // send request upload image
      return this.$store.dispatch("image/postImg", formData);
    });
    await Promise.all(promises);
    await this.$store.dispatch("image/getImages");
  }
}
